import type { Resource } from '@medplum/fhirtypes';
import { withTenantScope as _withTenantScope, withAuxiliaryOrgTag } from '@polarissleep/shared';

export { withAuxiliaryOrgTag };

const TENANT_ORG_ID: string | undefined = import.meta.env.VITE_MEDPLUM_ORGANIZATION_ID;

export function getOrganizationId(): string | undefined {
  return TENANT_ORG_ID;
}

/**
 * Applies `meta.account` to the resource using the tenant Organization ID from env.
 */
export function withTenantScope<T extends Resource>(resource: T, orgId = TENANT_ORG_ID): T {
  return _withTenantScope(resource, orgId);
}
